import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { DTO_REQUEST__generation_start } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_start';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { FN_GENERATION__status_lock } from '../_methods/FN_GENERATION__status_lock';
import { FN_GENERATION__status_unlock } from '../_methods/FN_GENERATION__status_unlock';
import { FN_GENERATION__update_locally } from '../_methods/FN_GENERATION__update_locally';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_start = createAsyncThunkSafe<string, DTO_REQUEST__generation_start>(
  ENUM__network_event_client_to_server.GENERATION_START,
  async (request: DTO_REQUEST__generation_start) => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_START, request);

    return request.generation_id;
  },
);

export function INIT_REMOTE__generation_start(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_start.pending, (state, action) => {
      let request = action.meta.arg;

      let { generation_id } = request;

      FN_GENERATION__status_lock(state, generation_id);

      let generation = state.generations_map.get_or_assert(generation_id, { context: 'generation' });

      generation.assert_statuses(CONSTANTS__shared.ALLOWED_STATUSES_TO_GENERATION_START);

      generation = generation.clone({ status: ENUM__generation_status.IN_PROGRESS });

      FN_GENERATION__update_locally(state, generation);
    })
    .addCase(REMOTE__generation_start.rejected, (state, action) => {
      FN_GENERATION__status_unlock(state, action.meta.arg.generation_id);
    })
    .addCase(REMOTE__generation_start.fulfilled, (state, action: PayloadAction<string>) => {
      FN_GENERATION__status_unlock(state, action.payload);
    });
}
